import ExportMenu from "components/ExportMenu";
import DashboardInadimplentes from "./../DashboardInadimplentes/index";
import ListingPageHeaderBar from "components/Page/ListingPageHeaderBar/index";
import { Empty } from "antd";
import { Skeleton } from "@chakra-ui/react";
import ItemInadimplente from "./../ItemInadimplente";
import { formatMoney } from "infra/helpers/number";
import CardDefault from "components/Cards/CardDefault";
import { Box, Text, Flex } from "@chakra-ui/layout";
import { RelatorioInadimplentesQueryParams } from "core/features/relatorios/typings/index";
import ModalFiltrosRelatorioInadimplentes from "./../ModalFiltrosRelatorioInadimplentes/index";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { RelatorioInadimplentesItem } from "core/features/relatorios/typings/index";
import { DashboardInadimplentesResponse } from "core/features/relatorios/typings/index";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";
import ModalComposicaoConta from "components/ModalComposicaoConta";
import ButtonResumoPorCategoria from "components/Button/ButtonResumoPorCategoria";
import { OperacaoEnum } from "../../../../../../../../core/resources/enums/conta";
import { ComposicaoItem } from "core/features/conta/typings";
import { ResumoCategoriaItem } from "core/features/relatorios/typings";

interface InadimplentesContentProps {
  isLoading: boolean;
  data: RelatorioInadimplentesItem[];
  isLoadingDashboard: boolean;
  dashboard: DashboardInadimplentesResponse | undefined;
  onExportPdf: (() => void) | undefined;
  onExportExcel: (() => void) | undefined;
  filtro: RelatorioInadimplentesQueryParams;
  onChangeFiltro: (_filtro: Partial<RelatorioInadimplentesQueryParams>) => void;
  onResetFiltro: () => void;
  refetch: (options?: any | undefined) => Promise<any>;
  fetchNextPage: () => any;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

export default function InadimplentesContent({
  data,
  isFetchingNextPage,
  dashboard,
  isLoading,
  isLoadingDashboard,
  filtro,
  onChangeFiltro,
  onResetFiltro,
  fetchNextPage,
  hasNextPage,
  onExportExcel,
  onExportPdf,
}: InadimplentesContentProps) {
  const [isOpenModalFiltro, setIsOpenModalFiltro] = useState(false);
  const [isOpenModalResumoCategoria, setIsOpenModalResumoCategoria] =
    useState(false);

  const numeroFiltroSelecionados =
    (filtro.contasBancariasIds?.length ? 1 : 0) +
    (filtro.centrosDeCustoIds?.length ? 1 : 0) +
    (filtro.cpf ? 1 : 0) +
    (filtro.dataInicio || filtro.dataFim ? 1 : 0) +
    (filtro.setor ? 1 : 0) +
    (filtro.porcentagemHonorarios ? 1 : 0);

  const resumoReceitas =
    dashboard?.resumoPorCategoria?.filter(
      (item) => item.operacao === OperacaoEnum.Receita
    ) ?? [];
  const resumoDespesas =
    dashboard?.resumoPorCategoria?.filter(
      (item) => item.operacao === OperacaoEnum.Despesa
    ) ?? [];

  const mapItemResumo = (item: ResumoCategoriaItem): ComposicaoItem => {
    return {
      valor: item.valor,
      categoriaFinanceiraId: item.id,
      categoriaFinanceira: {
        breadcrumb: item.breadcrumb,
        operacao: item.operacao!,
        nome: item.nome,
        id: item.id,
      },
    };
  };

  return (
    <>
      <DashboardInadimplentes
        isLoading={isLoadingDashboard}
        porcentagemInadimplente={
          (100 * (dashboard?.numeroInadimplentes || 0)) /
          (dashboard?.totalUnidades || 1)
        }
        totalDivida={dashboard?.total}
        totalDividaPrincipal={dashboard?.totalPrincipal}
        totalInadimplentes={dashboard?.numeroInadimplentes}
      />

      <ListingPageHeaderBar
        valueSearch={filtro.search}
        onSearch={(search) => onChangeFiltro({ search })}
        visibleFiltro
        badge
        badgeValue={numeroFiltroSelecionados}
        onFiltro={() => setIsOpenModalFiltro(true)}
        children={
          <Flex justifyContent="flex-end" w="100%" gap={4}>
            {dashboard?.resumoPorCategoria ? (
              <ButtonResumoPorCategoria
                onClick={() => setIsOpenModalResumoCategoria(true)}
              />
            ) : null}

            <ExportMenu
              onExportPdf={onExportPdf}
              onExportarXlsx={onExportExcel}
            />
          </Flex>
        }
      />

      <CardDefault
        mt={6}
        p={0}
        pt={"12px"}
        pb={data.length && !isLoading ? 0 : "24px"}
      >
        {isLoadingDashboard ? (
          <Flex px="16px">
            <Skeleton w="100%" h="24px" />
          </Flex>
        ) : (
          <Flex
            pl="16px"
            pr={6}
            justifyContent="space-between"
            alignItems="center"
          >
            <Text fontWeight="bold">
              {dashboard?.numeroInadimplentes}
              {dashboard?.numeroInadimplentes === 1
                ? " inadimplente"
                : " inadimplentes"}
            </Text>

            <Text fontWeight="bold">
              Total: {formatMoney(dashboard?.total)}
            </Text>
          </Flex>
        )}

        <Box mt={4}>
          {isLoading ? (
            <>
              <Skeleton w="100%" h="200px" />
            </>
          ) : null}

          {!isLoading && !data.length ? (
            <Empty description="Sem inadimplentes" />
          ) : null}

          {!isLoading && data.length ? (
            <>
              <InfiniteScroll
                dataLength={data.length}
                next={() => {
                  fetchNextPage();
                }}
                hasMore={!!hasNextPage}
                loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
              >
                {data.map((item) => (
                  <ItemInadimplente item={item} key={item.unidadeId} />
                ))}
              </InfiniteScroll>
            </>
          ) : null}
        </Box>
      </CardDefault>

      <ModalFiltrosRelatorioInadimplentes
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        onReset={onResetFiltro}
        visible={isOpenModalFiltro}
        onClose={() => setIsOpenModalFiltro(false)}
      />

      {dashboard?.resumoPorCategoria ? (
        <ModalComposicaoConta
          tableTitle="Categoria"
          data={{
            composicoes: resumoReceitas?.map(mapItemResumo),
            retencoes: resumoDespesas?.map(mapItemResumo),
            totalRetencao: resumoDespesas?.reduce(
              (acc, next) => (acc += next.valor),
              0
            ),
            total: dashboard.total,
          }}
          onClose={() => setIsOpenModalResumoCategoria(false)}
          isOpen={isOpenModalResumoCategoria}
          title="Resumo por categoria"
        />
      ) : null}
    </>
  );
}
